import * as React from "react";
const SvgFiRrMartiniGlassEmpty = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-martini-glass-empty_svg__a)">
      <path
        fill="#062147"
        d="M23.782 2.025A3.15 3.15 0 0 0 20.844 0H3.156A3.15 3.15 0 0 0 .218 2.025c-.466 1.19-.183 2.459.77 3.34l8.15 7.528c.548.498 1.19.829 1.863.992V22H7a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2h-4v-8.116a4.3 4.3 0 0 0 1.869-.997l8.173-7.551c.922-.853 1.206-2.121.74-3.312zm-2.128 1.871-8.136 7.517A2.37 2.37 0 0 1 12 12c-.5 0-1.101-.208-1.512-.581L2.315 3.868c-.445-.411-.312-.916-.235-1.114C2.223 2.39 2.58 2 3.156 2h17.688c.576 0 .934.39 1.076.754.078.198.21.703-.266 1.143z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-martini-glass-empty_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMartiniGlassEmpty;
